import type { FC } from 'react'

import { Table } from '@skytech/ui'
import { Td } from '@skytech/ui/Table/Td'
import { useDispatch, useSelector } from 'react-redux'

import Button from '@/components/form/Button'
import { Translation } from '@/components/i18n/Translation'
import { getCostObjects } from '@/ducks/costObjectsReducer'
import { activatePopup } from '@/ducks/popupReducer'
import withCostObjectsLoaded from '@/hocs/withCostObjectsLoaded'
import useRenderLimit from '@/hooks/render-limit-hook'

import NewCostObjectForm from './NewCostObjectForm'

import './tab-cost-objects.scss'

const TabCostObjects: FC = () => {
  const dispatch = useDispatch()

  const costObjects = useSelector(getCostObjects)

  const { visibleList, ListLoaderComponent } = useRenderLimit(costObjects)

  return (
    <div className="tab-cost-objects">
      <Button onClick={() => dispatch(activatePopup(<NewCostObjectForm />))}>
        <Translation id="Add Number" />
      </Button>

      <Table rowHeight="medium">
        <thead>
          <tr>
            <th>
              <Translation id="Number" />
            </th>
            <th className="px-4 text-left">
              <Translation id="Name" />
            </th>
          </tr>
        </thead>
        <tbody>
          {visibleList.map((costObject: any) => (
            <CostObject key={costObject.id} {...costObject} />
          ))}
        </tbody>
      </Table>

      <ListLoaderComponent />
    </div>
  )
}

export default withCostObjectsLoaded(TabCostObjects)

const CostObject: FC<any> = ({ code, name }) => (
  <tr>
    <Td>{code}</Td>
    <Td>{name}</Td>
  </tr>
)
